import {isPast, parseISO, getUnixTime, fromUnixTime, differenceInBusinessDays, format, differenceInMinutes} from 'date-fns'

export class CustomDate {
  constructor({ shippingCutoff, storeTimezone, estimatedShippingTime, storeCurrentDate, dayOfTheWeek}){
    if (!storeTimezone) {
      return console.error('Error occured, no timezone data passed to initTimer');
    }
    if (!shippingCutoff){
      return console.error("No Shipping Cutoff Date specified!");
    }

    this.storeCurrentDate = storeCurrentDate;
    this.shippingCutoff = shippingCutoff;
    this.dayOfTheWeek = dayOfTheWeek;
    this.storeTimezone = storeTimezone;

    this.estimatedShippingTime = parseInt(estimatedShippingTime); // Need to Bake this into Module.

    this.cutOffShipmentTime = parseISO(
        `${this.storeCurrentDate}T${this.shippingCutoff}${this.storeTimezone}`,
    );

    this.timeUntilNextShipmentCutoff = this.cutOffShipmentTime;


    if(this.isTimePastCutoff()){
      this.estimatedShippingTime++;
    }

    if(this.isPastShippingTime()) {
      // Increase Shipment time by 1 day
      this.timeUntilNextShipmentCutoff = this.updateDate(this.timeUntilNextShipmentCutoff, 1);
    }

    this.estimatedShippingDate = this.cutOffShipmentTime;

    while(this.estimatedShippingTime > 0){
      const newShippingDate = this.updateDate(this.estimatedShippingDate, this.estimatedShippingTime);
      const numberOfBusinessDaysRequired = this.calculateDifferenceBusinessDays(this.estimatedShippingDate, newShippingDate);
      this.estimatedShippingTime = this.estimatedShippingTime + numberOfBusinessDaysRequired;
      this.estimatedShippingDate = newShippingDate;
    }
  }

  getTimeLeft() {
    const totalMinutes = differenceInMinutes(this.timeUntilNextShipmentCutoff, Date.now());
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const h = hours === 1 ? '' : 's';
    const m = minutes === 1 ? '': 's';
    const hoursText = hours !== 0 ? `${hours} hour${h} and `: '';
    const minutesText = minutes !== 0 ? `${minutes} minute${m}!`: '';

    return `${hoursText}${minutesText}`;
  }

  calculateDifferenceBusinessDays(a,b){
    return differenceInBusinessDays(a,b);
  }

  updateDate(date, days){
    const seconds = days * 24 * 60 * 60;
    return fromUnixTime(getUnixTime(date) + seconds);
  }

  /**
   * @return {boolean} - Returns True if the CutOff Time is in the Past else false.
   */
  isTimePastCutoff() {
    const regex = RegExp('friday|saturday|sunday', 'i')
    return isPast(this.cutOffShipmentTime) && !regex.test(this.dayOfTheWeek);
  }

  isPastShippingTime() {
    return isPast(this.cutOffShipmentTime);
  }

  getEstimatedDate(){
    return format(this.estimatedShippingDate, "EEEE, MMM dd");
  }
}
